import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'
import { appendParams } from '@utils/func'

class PageSetupManagementApi implements IAPI {
  prefix = '/PageSetupManagement'

  fetchList (params: TPageSetupManagement.TState['searchParams']) {
    const url = appendParams(`${this.prefix}/GetList`, { ...params })
    return API.get<TPageSetupManagement.TState['pageSetupList']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TPageSetupManagement.TState['pageSetupUpsert']>(`${this.prefix}/GetById?id=${id}`)
  }

  fetchCodeAndNameList () {
    return API.get<TPageSetupManagement.CodeAndNameList>(`${this.prefix}/GetCodeAndNameList`)
  }

  async create (data: any) {
    const response = await API.post<TPageSetupManagement.TState['pageSetupUpsert']>(`${this.prefix}/Create`, data)
    return response.data
  }

  async update (data: any) {
    const response = await API.put<TPageSetupManagement.TState['pageSetupUpsert']>(`${this.prefix}/Update`, data)
    return response.data
  }

  async delete (id: string) {
    const response = await API.delete(`${this.prefix}/Delete?id=${id}`)
    return response.data
  }

  async fetchDisplayScreenOptionList () {
    const response = await API.get<TPageSetupManagement.TState['displayScreenOptionList']>(`${this.prefix}/GetDisplayScreenOptionList`)
    return response
  }

  async fetchSortedAndFilterOptions (code: string) {
    const response = await API.get<TPageSetupManagement.TState['sortAndFilterOptionList']>(`${this.prefix}/GetSortedAndFilterOptions?code=${code}`)
    return response
  }
}

export const pageSetupManagementApi = new PageSetupManagementApi()
